// extracted by mini-css-extract-plugin
export default {"simpleButton":"SongDetails_simpleButton__Oowl3","songDetailsContainer":"SongDetails_songDetailsContainer__Le3UL"};